<div class="dark-background">
  <div class="img-container">
    <div
      class="img-logo"
      theming
      themingGroup="dailychallenge"
      themingAsset="logo"
      [themingOverride]="pendingRewardsModalData?.properties?.assets"></div>
    <div
      class="img-background"
      theming
      themingGroup="dailychallenge"
      themingAsset="reward-background"
      [themingOverride]="pendingRewardsModalData?.properties?.assets"></div>
  </div>
  <div class="text-container">
    <slotcom-p
      class="text-title"
      [bold]="true"
      [text]="'home.daily-challenge.pending-rewards.title' | translate | uppercase"
      [shadowBorder]="true"></slotcom-p>
    <slotcom-p
      class="text-confirmation"
      [bold]="true"
      [text]="'home.daily-challenge.pending-rewards.content' | translate"
      [shadowBorder]="true"></slotcom-p>
  </div>
  <div class="reward-container">
    @if (pendingRewardsModalData.reward.credits > 0) {
      <div
        class="reward"
        theming
        themingGroup="dailychallenge"
        themingAsset="reward-challenge-box"
        [themingOverride]="pendingRewardsModalData?.properties?.assets">
        <div
          class="reward-icon"
          theming
          themingGroup="none"
          themingAsset="credits"></div>

        <span class="reward-number">
          {{ pendingRewardsModalData.reward.credits | beautifyNumber: ('common.culture' | translate) }}
        </span>
      </div>
    }

    @if (pendingRewardsModalData.reward.gems > 0) {
      <div
        class="reward"
        theming
        themingGroup="dailychallenge"
        themingAsset="reward-challenge-box"
        [themingOverride]="pendingRewardsModalData?.properties?.assets">
        <div
          class="reward-icon"
          theming
          themingGroup="none"
          themingAsset="gems"></div>

        <span class="reward-number">
          {{ pendingRewardsModalData.reward.gems | beautifyNumber: ('common.culture' | translate) }}
        </span>
      </div>
    }

    @if (pendingRewardsModalData.prestigeReward > 0) {
      <div
        class="reward"
        theming
        themingGroup="dailychallenge"
        themingAsset="reward-challenge-box"
        [themingOverride]="pendingRewardsModalData?.properties?.assets">
        <div
          class="reward-icon"
          theming
          themingGroup="progressline"
          themingAsset="prestige-logo"></div>

        <span class="reward-number">
          {{ pendingRewardsModalData.prestigeReward | beautifyNumber: ('common.culture' | translate) }}
        </span>
      </div>
    }
  </div>
  <slotcom-button
    class="custom-button c-button--pink"
    (click)="close()"
    audioType="reward">
    {{ 'home.daily-challenge.pending-rewards.thanks' | translate | uppercase }}
  </slotcom-button>
</div>
